import React, { useState } from 'react';
import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';

type FileIconProps = {
  alt: string;
  className: string;
  file: appStorageRecords.AppStorageFile;
};

const FileIcon: React.FC<FileIconProps> = ({
  alt,
  className,
  file,
}) => {
  const [imageSrc, setImageSrc] = useState(file.getIconUrl());

  return (
    <img
      alt={alt}
      className={className}
      data-ot-ignore
      onError={() => setImageSrc(file.getFallbackIconUrl())}
      src={imageSrc}
    />
  );
};

export default FileIcon;
